import React from 'react';

import { Tooltip } from 'antd-v5';
import { MdInfo } from 'react-icons/md';
import { FormattedMessage } from 'react-intl';
import { Text } from 'scouting-ui/lib';

import { featureFlags } from '@modules/featureFlags/utils/featureFlags';

import styles from './SubjectCharactersTooltip.less';

export default function SubjectCharactersTooltip() {
  const isLaxSubjectPattern = featureFlags.getFlag(
    'SBL_6856_LAX_MESSAGING_CHARACTERS',
  );

  if (!isLaxSubjectPattern) return null;

  return (
    <Tooltip
      title={
        <>
          <Text paragraph color="color-white">
            <FormattedMessage id="messaging.allowedCharactersTooltip.title" />
          </Text>
          <Text paragraph color="color-white">
            <FormattedMessage id="messaging.allowedCharactersTooltip.letters" />
          </Text>
          <Text paragraph color="color-white">
            <FormattedMessage id="messaging.allowedCharactersTooltip.numbers" />
          </Text>
          <Text paragraph color="color-white">
            <FormattedMessage id="messaging.allowedCharactersTooltip.accented" />
          </Text>
          <Text paragraph color="color-white">
            <FormattedMessage id="messaging.allowedCharactersTooltip.whitespace" />
          </Text>
          <Text paragraph color="color-white">
            <FormattedMessage id="messaging.allowedCharactersTooltip.symbols" />
          </Text>
        </>
      }
    >
      <MdInfo className={styles.infoIcon} />
    </Tooltip>
  );
}
